module.exports = __webpack_public_path__ + "static/avatar_uriy_postrigay@2x-65649ac217abdfd2204320e7ac149c7e.jpg";